// API URL configuration
export const getApiUrl = () => {
  // In Discord Activity or production, use /api (proxy handles routing)
  if (window.location.hostname.includes('discordsays.com') || 
      window.location.hostname.includes('emergentagent.com') ||
      window.location.hostname.includes('akindo.org')) {
    return '/api';
  }
  // Local development - use full URL
  return process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : '/api';
};

// WebSocket URL - Discord Activity and production uses relative path through proxy
export const getWsUrl = () => {
  // In Discord Activity (iframe) or production, use current origin for WebSocket
  // The proxy handles routing via URL Mappings
  if (window.location.hostname.includes('discordsays.com') ||
      window.location.hostname.includes('emergentagent.com') ||
      window.location.hostname.includes('akindo.org')) {
    // Use wss:// with current host
    return `wss://${window.location.host}`;
  }
  // Local development - use backend URL
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl) {
    return backendUrl.replace('https://', 'wss://').replace('http://', 'ws://');
  }
  // Fallback to current host
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}`;
};

export const isDiscordActivity = () => true; // Default to Discord mode
